import { array, number, object, string } from "yup";
import {
  PlanFeatureResource,
  planFeatureResourceSchema,
} from "./PlanFeatureResource";
import {
  PlanVariantResource,
  planVariantResourceSchema,
} from "./PlanVariantResource";
import {
  PlanAddonResource,
  planAddonResourceSchema,
} from "./PlanAddonResource";
import { SubscriptionPlanCode } from "./CurrentSubscriptionResource";

// export enum PlanCode {
//   Trial = "trial",
//   Growth = "growth",
//   UnlimitedGrowth = "unlimited_growth",
//   UnlimitedGrowthAi = "unlimited_growth_ai",
//   Starter = "starter",
//   Scale = "scale",
//   College = "college",
//   Free = "free",
//   Enterprise = "enterprise",
//   ProAi = "pro_ai",
//   Pro = "pro",
// }

export interface PlanResource {
  id: number;
  name: string;
  code: SubscriptionPlanCode;
  description: string | null;
  variants: PlanVariantResource[];
  features: PlanFeatureResource[];
  addons: PlanAddonResource[];
}

export const planResourceSchema = object({
  id: number().required(),
  name: string().required(),
  code: string().oneOf(Object.values(SubscriptionPlanCode)).required(),
  description: string().nullable().default(null),
  variants: array().of(planVariantResourceSchema).required(),
  features: array().of(planFeatureResourceSchema).required(),
  addons: array().of(planAddonResourceSchema).required(),
});
